import { describe_error } from './ErrorDescriber';
import axios from 'axios';

import Constants from '../Constants';

// Whether the user has an analysis they started, page or site, still going (GET /api/analysis_running): the Analyze
// and Run buttons are disabled while one is. false when the answer cannot be read.
export const fetch_analysis_running = async(token)=>{
	try {
		const response = await axios.get(Constants.SERVER_URL + '/api/analysis_running', { headers: { Authorization: 'Bearer ' + token } });
		return (response.data !== null) && (response.data.running === true);
	}
	catch (error) {
		console.log('AnalysisRunning/fetch_analysis_running - ERROR: ', describe_error(error));
		return false;
	}
};
